
import { Component, Vue, Prop } from "vue-property-decorator"
import vSelect from "vue-select"
import { ShiftPattern } from "@/types/timeManagement"
import TimeDurationPicker from "@/components/CaseDetails/Users/TimeDurationPicker.vue"

@Component({
	components: {
		"v-select": vSelect,
		"time-duration-picker": TimeDurationPicker
	}
})
export default class ShiftPatternSetup extends Vue {
	@Prop()
	value!: ShiftPattern[]

	private loading = false

	mounted () {
		this.patterns.forEach(p => {
			if (!p.color) p.color = "#000000"
		})
	}

	private get columns () {
		return [
			{ key: "title", label: "Title", thStyle: { width: "8rem" }, tdClass: "col-title" },
			{ key: "durationHours", label: "Duration", thStyle: { width: "8rem" }, tdClass: "col-duration" },
			{ key: "color", label: "Color", thStyle: { width: "8rem" }, tdClass: "col-color" },
			{ key: "controls", label: "", thStyle: { width: "4rem" }, tdClass: "col-controls" }
		]
	}

	private get patterns (): ShiftPattern[] {
		return this.value || []
	}

	private get duplicatedTitles (): Set<string> {
		const counts: Record<string, number> = {}
		this.patterns.forEach(p => {
			const t = p.title?.trim()
			if (t) counts[t] = (counts[t] || 0) + 1
		})
		return new Set(Object.keys(counts).filter(t => counts[t] > 1))
	}

	private isTitleValid (pattern: ShiftPattern): boolean | null {
		const title = (pattern.title || "").trim()
		if (!title) return false
		if (this.duplicatedTitles.has(title)) return false
		return true
	}

	private titleErrorMessage (pattern: ShiftPattern): string | null {
		const title = (pattern.title || "").trim()
		if (!title) return "Title is required"
		if (this.duplicatedTitles.has(title)) return "Duplicate title"
		return null
	}

	private add () {
		const newPattern: ShiftPattern = {
			id: null,
			title: "New Shift",
			durationHours: 0,
			color: "#000000"
		}
		this.$emit("input", [...this.patterns, newPattern])
	}

	private update (pattern: ShiftPattern, field: keyof ShiftPattern, value: any) {
		const updated = this.patterns.map(p =>
			(pattern.id ? p.id === pattern.id : p === pattern)
				? { ...p, [field]: value }
				: p
		)
		this.$emit("input", updated)
	}

	private remove (pattern: ShiftPattern) {
		const filtered = this.patterns.filter(p =>
			pattern.id ? p.id !== pattern.id : p !== pattern
		)
		this.$emit("input", filtered)
	}
}
